import * as z from 'zod';
import {
  localizedTextSchema,
  type LocalizedTextInput,
  type LocalizedTextPatch,
} from './localized';
import { pendingChangeSchema } from './media';

export const restaurantBannerSchema = z
  .object({
    id: z.string(),
    restaurant_id: z.string().nullish(),
    merchant_id: z.string().nullish(),
    product_id: z.string().nullish(),
    placement: z.string().nullish(),
    type: z.string().nullish(),
    search: z.object({ min_discount_percent: z.number().nullish() }).nullish(),
    title: localizedTextSchema.nullish(),
    image: localizedTextSchema.nullish(),
    is_active: z.boolean().nullish(),
    position: z.number().nullish(),
    created_at: z.string().nullish(),
    updated_at: z.string().nullish(),
    lifecycle_status: z.string().nullish(),
  })
  .loose();
export type RestaurantBanner = z.infer<typeof restaurantBannerSchema>;

export const restaurantBannerResponseSchema = z
  .object({
    banner: restaurantBannerSchema.nullish(),
    pending_change: pendingChangeSchema.nullish(),
  })
  .loose();

export interface CreateRestaurantBannerInput {
  restaurant_id?: string | undefined;
  merchant_id?: string | undefined;
  product_id?: string | undefined;
  placement?: string | undefined;
  type?: string | undefined;
  search?: { min_discount_percent: number } | undefined;
  title: LocalizedTextInput;
  image?: LocalizedTextInput;
  position?: number | undefined;
}

export interface UpdateRestaurantBannerInput {
  title?: LocalizedTextInput | undefined;
  image?: LocalizedTextPatch | undefined;
  is_active?: boolean | undefined;
  position?: number | undefined;
  restaurant_id?: string | undefined;
  merchant_id?: string | undefined;
  product_id?: string | undefined;
  placement?: string | undefined;
  type?: string | undefined;
  search?: { min_discount_percent: number } | undefined;
}
